import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getAllItem } from '../actions/async.action';

const initialState = {
    items: [],
    status: 'idle',
    error: null
}

export const fetchItems = createAsyncThunk('items/fetchItems', async () => {
    const response = await getAllItem();
    return response.data
})

const itemsSlice = createSlice({
    name: 'items',
    initialState,
    reducers: {
        addItem: (state, action) => {
            state.items.push(action.payload)
        },
        updateItem: (state, action) => {
            const { id, updates } = action.payload
            const existingItem = state.items.find(item => item.Id === id)
            if (existingItem) {
                Object.assign(existingItem, updates)
            }
        },
        removeItem: (state, action) => {
            state.items = state.items.filter(item => item.Id !== action.payload)
        }
    },
    extraReducers(builder) {
        builder
          .addCase(fetchItems.pending, (state, action) => {
            state.status = 'loading'
          })
          .addCase(fetchItems.fulfilled, (state, action) => {
            state.status = 'succeeded'
            // Replace the items array with fetched items
            state.items = action.payload
          })
          .addCase(fetchItems.rejected, (state, action) => {
            state.status = 'failed'
            state.error = action.error.message
          })
      }
  })

export const { addItem, updateItem, removeItem } = itemsSlice.actions
export default itemsSlice.reducer
